export const { downloadContract, initializeCheckout, livenessCheck } = {
	downloadContract: "/handlers/download-contract-note",
	initializeCheckout: "/checkout/initialize",
	livenessCheck: "/files/upload-liveness-video",
};
